import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticated = false;
  private http = inject(HttpClient);
  url = 'user/auth'
    constructor() {
      this.isAuthenticated = !!localStorage.getItem('access_token');
  }
  getApiUrl = () => {
    return environment.backendUrl + this.url;
  }
  authenticate = (): Observable<Object> => {
    const token = localStorage.getItem('access_token');
    if (!token || token === 'undefined') {
      return throwError(() => new Error('No token found'));
    }
    return this.http.get(this.getApiUrl(), {
      headers: { Authorization: `Bearer ${token}` }
    });
  }
}
